import { render, staticRenderFns } from "./snowLeopard.vue?vue&type=template&id=1cc01150&"
import script from "./snowLeopard.vue?vue&type=script&lang=ts&"
export * from "./snowLeopard.vue?vue&type=script&lang=ts&"
import style0 from "./snowLeopard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports